import React, { ReactNode, CSSProperties } from "react"

type TextProps = {
  children: ReactNode
  size?: number
  color?: string
  type?: "small" | "medium"
  style?: CSSProperties
}

const smallType: CSSProperties = {
  color: "#689",
  fontSize: "14px",
  fontWeight: 400,
  marginBottom: "12px",
}

const mediumType: CSSProperties = {
  color: "#9AB0BC",
  fontSize: "18px",
  fontWeight: 400,
  marginBottom: "12px",
}

const Text = ({ children, size, color, type, style = {} }: TextProps) => {
  //
  const textStyle: CSSProperties = {
    ...(type === "small" && smallType),
    ...(type === "medium" && mediumType),
    ...(size && { fontSize: `${size}px` }),
    ...(color && { color: color }),
  }
  return <span style={{ ...textStyle, ...style }}>{children}</span>
}

export default Text
